import React from "react";
import {
  Container,
  Box,
  Typography,
  Divider,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import MemberCard from "./UI/MemberCard";
import FelixFischer from "../assets/TeamMembers/felix_fischer.jpg"
import PhilippFischer from "../assets/TeamMembers/PhilippFischer.jpg"
import KilianRick from "../assets/TeamMembers/KilianRick.png"
import SamyAkrout from "../assets/TeamMembers/SamyAkrout.jpeg"
import AboutUsImg from "../assets/LandingPage/ourVision.jpg"
import IdeaImg from "../assets/LandingPage/theIdea.jpg"


const AboutUs = () => {
  const { t } = useTranslation();

  // Pull structured sections from i18n (arrays/objects)
  const sections = t("aboutUs.sections", { returnObjects: true });




  return (
    <Container
      
      sx={{
        minHeight: "100vh", // full screen height
        display: "flex",
        justifyContent: "center", // horizontal center
        alignItems: "center", // vertical center
        px: 4,

      }}
    >
      <Box
        className="white-background"
        sx={{
          width: "100%",
          maxWidth: "100%",
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <Typography variant="h3" color="primary" gutterBottom sx={{fontWeight: "bold", marginTop:8}}>
          {t("aboutUs.title")}
        </Typography>

        {t("aboutUs.intro") && (
          <Typography variant="body1" color="text.secondary" paragraph sx={{fontWeight: "bold"}}>
            {t("aboutUs.intro")}
          </Typography>
        )}

        <Divider sx={{ my: 3 }} />

        {/* Top-level sections */}
            <Box sx={{ textAlign: "left", mb: 4 }}>
                <Typography variant="h5" color="primary" >
                  {sections[0].title}
                </Typography>
              {/* Our Vision */}
              <Box sx={{display:{sx:"block", sm:"flex"} , gap:"30px", alignItems:"center", marginBottom:4}}>
                <Box sx={{marginBottom:"16px"}}>
                  <Typography  sx={{textAlign:"justify"}} variant="body1">{sections[0].paragraphs[0]}</Typography>
                  <Typography sx={{textAlign:"justify"}}  variant="body1">{sections[0].paragraphs[1]}</Typography>
                </Box>
                <img style={{height:"300px", borderRadius: 5}} src={AboutUsImg} alt="Our Vision" />
              </Box>

              <Divider sx={{ my: 3 }} />

              {/* How the idea came about: We have..*/}
              <Typography variant="h5" color="primary" gutterBottom sx={{marginBottom:4}}>
                {sections[1].title}
              </Typography>
              <Box sx={{display:{sx:"block", sm:"flex"}, gap:"30px", alignItems:"center", marginBottom:4}}>
                <Box sx={{height:{sx:"300px", sm:"600px"}, width:{sx:"250px", sm:"2200px"}}}>
                  <img style={{height:"100%", width:"100%", borderRadius: 5}} src={IdeaImg} alt="Our Vision" />
                </Box>
                
                <Box sx={{display:"flex", flexDirection:"column", gap:"10px",}}>
                  <Box>
                    <Typography  style={{paddingBottom:"5px", fontWeight:"bold"}}>{sections[1].subsections[0].title}</Typography>
                    <Typography sx={{textAlign:"justify"}}>{sections[1].subsections[0].paragraphs}</Typography>
                  </Box>
                  <Box>
                    <Typography style={{paddingBottom:"5px", fontWeight:"bold"}}>{sections[1].subsections[1].title}</Typography>
                    <Typography sx={{textAlign:"justify"}}>{sections[1].subsections[1].paragraphs}</Typography>
                  </Box>
                  <Box>
                    <Typography style={{paddingBottom:"5px", fontWeight:"bold"}}>{sections[1].subsections[2].title}</Typography>
                    <Typography sx={{textAlign:"justify"}}>{sections[1].subsections[2].paragraphs}</Typography>
                  </Box>
                </Box>
              </Box>

              <Divider sx={{ my: 4 }} />

              {/* Team block */}
              <Typography variant="h5" color="primary" gutterBottom sx={{my:4}}>
                {sections[2].title}
              </Typography>
              <Box sx={{display:"flex", flexDirection:"column", justifyContent: "center", alignItems:"center",my:4}}>
                <Typography sx={{marginBottom: 4}}>{sections[2].paragraphs}</Typography>
                <Box  sx={{display: "grid", gridTemplateColumns:{ xs: "1fr", md: "300px 1fr" }, gap:"10px", justifyContent: "center", alignItems:"center"   }}>
                    <MemberCard  name={sections[2].team[0].name} img={FelixFischer} role={sections[2].team[0].role}/>
                    <MemberCard  name={sections[2].team[1].name} img={PhilippFischer} role={sections[2].team[1].role}/>
                    <MemberCard  name={sections[2].team[2].name} img={KilianRick} role={sections[2].team[2].role}/>
                    <MemberCard  name={sections[2].team[3].name} img={SamyAkrout} role={sections[2].team[3].role}/>
                </Box>
              </Box>

              <Divider sx={{ my: 3 }} />

              {/* CTA */}
              <Typography variant="h5" color="primary" gutterBottom sx={{marginBottom:4}}>
                {sections[3].title}
              </Typography>
              <Box sx={{ textAlign: "center", mt: 2 }}>
                <Button
                    href={sections[3].ctaHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    sx={{ '&:hover': { color: 'white' } }}
                  >
                    {sections[3].ctaText}
                  </Button>
              </Box>
            </Box>
      </Box>
    </Container>
  );
};

export default AboutUs;
